import React from 'react';
import TableItem from '../Table';
import LineChartItem from '../LineChartItem';
import BarStackedChartItem from '../BarStackedChartItem';

interface CashFlowTabProps {
  companyData: any;
}

export default function CashFlowTab({ companyData }: CashFlowTabProps) {
  if (!companyData) return null;

  return (
    <div className="space-y-8 min-w-0">
      {/* Cash Flow Statement */}
      {companyData.cash_flow_statements && (
        <section className="bg-white rounded-xl border border-slate-200 p-6 overflow-hidden">
          <h3 className="text-lg font-semibold text-slate-900 mb-4">Cash Flow Statement</h3>
          <TableItem table={companyData.cash_flow_statements} head_bold={true} bold_column_indexes={[0]} />

          {companyData.cash_flow_statements_chart_data && (
            <div className="mt-6">
              <BarStackedChartItem
                name="Cash Flow Statement"
                x_axis={companyData.cash_flow_statements_chart_data.x_axis}
                data={companyData.cash_flow_statements_chart_data.data}
              />
            </div>
          )}
        </section>
      )}

      {/* Cash Flow Waterfall */}
      {companyData.cash_flow_waterfall && (
        <section className="bg-white rounded-xl border border-slate-200 p-6 overflow-hidden">
          <h3 className="text-lg font-semibold text-slate-900 mb-4">Cash Flow Waterfall</h3>
          <TableItem table={companyData.cash_flow_waterfall} head_bold={true} bold_column_indexes={[0]} />

          {companyData.cash_flow_waterfall_chart_data && (
            <div className="mt-6">
              <LineChartItem
                name="Cash Flow Waterfall"
                x_axis={companyData.cash_flow_waterfall_chart_data.x_axis}
                data={companyData.cash_flow_waterfall_chart_data.data}
                order={companyData.cash_flow_waterfall_chart_data.order}
              />
            </div>
          )}
        </section>
      )}

      {/* Uses and Sources */}
      {companyData.uses_sources && (
        <section className="bg-white rounded-xl border border-slate-200 p-6 overflow-hidden">
          <h3 className="text-lg font-semibold text-slate-900 mb-4">Uses and Sources</h3>
          <TableItem table={companyData.uses_sources} head_bold={true} bold_column_indexes={[0, 2]} />
        </section>
      )}
    </div>
  );
}
